// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 제품 아이템 div 기반 스타일 */
.product-list-grid {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background-color: #fff;
    overflow: hidden;
}

.product-item {
    display: flex;
    align-items: center;
    padding: 15px;
    border-bottom: 1px solid #f0f0f0;
    background-color: #fff;
    transition: background-color 0.2s ease;
}

.product-item:last-child {
    border-bottom: none;
}

.product-item:hover {
    background-color: #f8f9fa;
}

.product-item.dragging {
    background-color: #e3f2fd;
    opacity: 0.7;
    transform: scale(1.02);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.product-drag-handle {
    cursor: grab;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    margin-right: 15px;
    border-radius: 4px;
    transition: background-color 0.2s ease;
}

.product-drag-handle:hover {
    background-color: #e0e0e0;
}

.product-drag-handle:active {
    cursor: grabbing;
}

.product-image {
    margin-right: 15px;
    flex-shrink: 0;
}

.product-info {
    flex-grow: 1;
    min-width: 0;
}

.product-name {
    font-weight: 600;
    font-size: 16px;
    color: #333;
    margin-bottom: 5px;
}

.product-details {
    font-size: 14px;
    color: #666;
}

.product-details span {
    margin: 0 5px;
}

.product-actions {
    flex-shrink: 0;
    margin-left: 15px;
}

.no-products-message {
    text-align: center;
    padding: 50px;
    color: #999;
    font-size: 16px;
}

/* 드래그 앤 드롭 스타일 */
.drag-handle {
    cursor: grab;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    border-radius: 3px;
    transition: background-color 0.2s ease;
}

.drag-handle:hover {
    background-color: #f5f5f5;
}

.drag-handle:active {
    cursor: grabbing;
}

.product-row.dragging {
    opacity: 0.5;
    background-color: #f8f9fa;
}

/* 상품 진열 관리 모드 스타일 */
.display-management-container {
    margin-top: 20px;
}

.category-selection {
    background-color: #f8f9fa;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 20px;
    border: 1px solid #e0e0e0;
}

.category-selection .filter-row {
    margin-bottom: 15px;
}

.category-selection .filter-row:last-child {
    margin-bottom: 0;
}

.help-text {
    color: #666;
    font-size: 14px;
    font-style: italic;
}

/* 사이드바 스타일 추가 */
.admin-sidebar {
    width: 220px;
    margin-right: 30px;
}

.sidebar-menu {
    margin-bottom: 34px;
}

.sidebar-menu h3 {
    font-size: 18px;
    margin: 0 0 15px 0;
}

.sidebar-menu ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.sidebar-menu ul li {
    padding: 10px 20px;
    cursor: pointer;
    font-size: 14px;
    color: #717171;
    transition: background-color 0.2s ease, color 0.2s ease;
    border-radius: 4px;
    margin-bottom: 2px;
}

.sidebar-menu ul li:hover {
    background-color: #f5f5f5;
    color: #333;
}

.sidebar-menu ul li.active {
    color: black;
    font-weight: bold;
    background-color: #e8f4f8;
}

.admin-content-product {
    flex-grow: 1;
}

.product-search-filters {
    border: 1px solid #ddd;
    padding: 20px;
    background-color: #f8f9fa;
    border-radius: 5px;
}

.filter-row {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    gap: 10px;
}

.filter-row:last-child {
    margin-bottom: 0;
}

.filter-row label {
    width: 100px;
    font-weight: bold;
    flex-shrink: 0;
}

.filter-select {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
}

.filter-input {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    flex-grow: 1;
}

.filter-date {
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 5px;
}

.date-shortcuts {
    display: flex;
    gap: 5px;
    margin-left: 10px;
}

.date-shortcuts button {
    padding: 5px 10px;
    border: 1px solid #ccc;
    background-color: #fff;
    cursor: pointer;
}

.filter-checkboxes {
    display: flex;
    gap: 20px;
}

.filter-checkboxes label {
    display: flex;
    align-items: center;
    gap: 5px;
    width: auto;
    cursor: pointer;
}

.filter-checkboxes input[type="radio"] {
    margin-right: 5px;
    cursor: pointer;
}

.display-status-control {
    display: flex;
    gap: 15px;
    align-items: center;
}

.display-status-control label {
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
    font-size: 14px;
}

.display-status-control input[type="radio"] {
    margin: 0;
    cursor: pointer;
}

.search-button-product {
    display: block;
    width: 343px;
    padding: 15px;
    background-color: #222;
    color: white;
    font-size: 18px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin: 30px auto;
}

.product-list-container {
    margin-top: 30px;
}

.product-list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

.product-list-header span {
    font-size: 16px;
    font-weight: bold;
}

.btn-add-product {
    background-color: white;
    border: 1px solid #ccc;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
}

.product-table {
    width: 100%;
    border-collapse: collapse;
    border-top: 2px solid #333;
}

.product-table th,
.product-table td {
    text-align: center;
    padding: 15px 10px;
    border-bottom: 1px solid #ddd;
}

.product-table th {
    font-weight: bold;
    background-color: #f8f9fa;
}

.product-table td img {
    max-width: 60px;
    height: auto;
}

/* 클릭 가능한 행 스타일 */
.clickable-row {
    transition: background-color 0.2s ease;
}

.clickable-row:hover {
    background-color: #f8f9fa;
}

/* 첫 번째 컬럼(체크박스 + 버튼) 너비 조정 */
.product-table th:first-child,
.product-table td:first-child {
    width: 150px;
    min-width: 150px;
    overflow: visible !important;
    white-space: nowrap !important;
}

/* 테이블 내 버튼 스타일 강제 적용 */
.product-table .product-actions {
    display: flex !important;
    flex-direction: row !important;
    gap: 5px !important;
    align-items: center !important;
    justify-content: center !important;
    min-width: 100px !important;
}

.product-table .btn-edit-product,
.product-table .btn-delete-product {
    display: inline-block !important;
    padding: 4px 8px !important;
    font-size: 11px !important;
    border-radius: 3px !important;
    border: 1px solid !important;
    cursor: pointer !important;
    text-decoration: none !important;
    min-width: 40px !important;
}

.product-table .btn-edit-product {
    background-color: #e84118 !important;
    color: white !important;
    border-color: #e84118 !important;
}

.product-table .btn-edit-product:hover {
    background-color: #d63384 !important;
    border-color: #d63384 !important;
}

.product-table .btn-delete-product {
    background-color: #6c757d !important;
    color: white !important;
    border-color: #6c757d !important;
}

.product-table .btn-delete-product:disabled {
    background-color: #f8f9fa !important;
    color: #6c757d !important;
    border-color: #dee2e6 !important;
    cursor: not-allowed !important;
    opacity: 0.6 !important;
}

.product-list-actions {
    margin-top: 20px;
    display: flex;
    gap: 10px;
}

.btn-delete-selected,
.btn-edit-selected {
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
}

.btn-delete-selected {
    background-color: #222;
    color: white;
    border: none;
}

.btn-edit-selected {
    background-color: white;
    border: 1px solid #ccc;
}

.pagination {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
}

.pagination button {
    background: none;
    border: 1px solid #ccc;
    padding: 5px 10px;
    cursor: pointer;
}

/* 제품 관리 버튼 스타일 */
.product-actions {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
    justify-content: center;
    min-width: 120px;
}

.btn-back-product,
.btn-edit-product,
.btn-delete-product {
    padding: 6px 12px;
    border-radius: 4px;
    font-size: 12px;
    cursor: pointer;
    border: 1px solid;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    white-space: nowrap;
    min-width: 50px;
}

.btn-back-product {
    background-color: #6c757d;
    color: white;
    border-color: #6c757d;
}

.btn-back-product:hover {
    background-color: #5a6268;
    border-color: #545b62;
}

.btn-edit-product {
    background-color: #e84118;
    color: white;
    border-color: #e84118;
}

.btn-edit-product:hover {
    background-color: #d63384;
    border-color: #d63384;
}

.btn-delete-product {
    background-color: #6c757d;
    color: white;
    border-color: #6c757d;
}

.btn-delete-product:hover:not(:disabled) {
    background-color: #dc3545;
    border-color: #dc3545;
}

.btn-delete-product:disabled {
    background-color: #f8f9fa;
    color: #6c757d;
    border-color: #dee2e6;
    cursor: not-allowed;
    opacity: 0.6;
}

.arrow-icon {
    font-size: 12px;
    font-weight: bold;
    line-height: 1;
}

/* Tablet and smaller devices */
@media (max-width: 1024px) {
    .filter-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;
    }
    
    .filter-row label {
        width: 100%;
    }

    .filter-select,
    .filter-input {
        width: 100%;
    }

    .date-shortcuts {
        margin-left: 0;
    }

    .search-button-product {
        width: 100%;
    }
}

/* Mobile devices */
@media (max-width: 768px) {
    .product-list-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }

    .product-table thead {
        display: none;
    }

    .product-table, .product-table tbody, .product-table tr, .product-table td {
        display: block;
        width: 100%;
    }

    .product-table tr {
        margin-bottom: 15px;
        border: 1px solid #ddd;
        border-radius: 5px;
        overflow: hidden;
    }

    .product-table td {
        text-align: right;
        padding-left: 50%;
        position: relative;
    }
    
    .product-table td::before {
        content: attr(data-label);
        position: absolute;
        left: 15px;
        width: calc(50% - 30px);
        padding-right: 10px;
        white-space: nowrap;
        text-align: left;
        font-weight: bold;
    }
    
    .product-list-actions {
        flex-direction: column;
    }
    
    .btn-delete-selected,
    .btn-edit-selected {
        width: 100%;
    }
    
    .product-actions {
        flex-direction: row;
        gap: 5px;
        min-width: auto;
    }
    
    .btn-back-product,
    .btn-edit-product,
    .btn-delete-product {
        max-width: 60px;
        padding: 4px 6px;
        font-size: 11px;
        min-width: 40px;
    }
} `, "",{"version":3,"sources":["webpack://./src/admin/css/ProductManagementPage.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;IACI,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,gCAAgC;IAChC,sBAAsB;IACtB,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,sBAAsB;IACtB,0CAA0C;AAC9C;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,eAAe;AACnB;;AAEA,iBAAiB;AACjB;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA,oBAAoB;AACpB;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA,gBAAgB;AAChB;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,cAAc;IACd,uDAAuD;IACvD,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA,iBAAiB;AACjB;IACI,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,6BAA6B;AAC7B;;IAEI,YAAY;IACZ,gBAAgB;IAChB,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA,uBAAuB;AACvB;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;IACnB,8BAA8B;IAC9B,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA;;IAEI,gCAAgC;IAChC,2BAA2B;IAC3B,0BAA0B;IAC1B,6BAA6B;IAC7B,4BAA4B;IAC5B,0BAA0B;IAC1B,gCAAgC;IAChC,0BAA0B;AAC9B;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,gCAAgC;IAChC,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,SAAS;AACb;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;AACnB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;;;IAGI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA,+BAA+B;AAC/B;IACI;QACI,sBAAsB;QACtB,uBAAuB;QACvB,QAAQ;IACZ;;IAEA;QACI,WAAW;IACf;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,mBAAmB;QACnB,sBAAsB;QACtB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,kBAAkB;QAClB,UAAU;QACV,uBAAuB;QACvB,mBAAmB;QACnB,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,mBAAmB;QACnB,QAAQ;QACR,eAAe;IACnB;;IAEA;;;QAGI,eAAe;QACf,gBAAgB;QAChB,eAAe;QACf,eAAe;IACnB;AACJ","sourcesContent":["/* 제품 아이템 div 기반 스타일 */\n.product-list-grid {\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    background-color: #fff;\n    overflow: hidden;\n}\n\n.product-item {\n    display: flex;\n    align-items: center;\n    padding: 15px;\n    border-bottom: 1px solid #f0f0f0;\n    background-color: #fff;\n    transition: background-color 0.2s ease;\n}\n\n.product-item:last-child {\n    border-bottom: none;\n}\n\n.product-item:hover {\n    background-color: #f8f9fa;\n}\n\n.product-item.dragging {\n    background-color: #e3f2fd;\n    opacity: 0.7;\n    transform: scale(1.02);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.product-drag-handle {\n    cursor: grab;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 8px;\n    margin-right: 15px;\n    border-radius: 4px;\n    transition: background-color 0.2s ease;\n}\n\n.product-drag-handle:hover {\n    background-color: #e0e0e0;\n}\n\n.product-drag-handle:active {\n    cursor: grabbing;\n}\n\n.product-image {\n    margin-right: 15px;\n    flex-shrink: 0;\n}\n\n.product-info {\n    flex-grow: 1;\n    min-width: 0;\n}\n\n.product-name {\n    font-weight: 600;\n    font-size: 16px;\n    color: #333;\n    margin-bottom: 5px;\n}\n\n.product-details {\n    font-size: 14px;\n    color: #666;\n}\n\n.product-details span {\n    margin: 0 5px;\n}\n\n.product-actions {\n    flex-shrink: 0;\n    margin-left: 15px;\n}\n\n.no-products-message {\n    text-align: center;\n    padding: 50px;\n    color: #999;\n    font-size: 16px;\n}\n\n/* 드래그 앤 드롭 스타일 */\n.drag-handle {\n    cursor: grab;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 4px;\n    border-radius: 3px;\n    transition: background-color 0.2s ease;\n}\n\n.drag-handle:hover {\n    background-color: #f5f5f5;\n}\n\n.drag-handle:active {\n    cursor: grabbing;\n}\n\n.product-row.dragging {\n    opacity: 0.5;\n    background-color: #f8f9fa;\n}\n\n/* 상품 진열 관리 모드 스타일 */\n.display-management-container {\n    margin-top: 20px;\n}\n\n.category-selection {\n    background-color: #f8f9fa;\n    padding: 20px;\n    border-radius: 8px;\n    margin-bottom: 20px;\n    border: 1px solid #e0e0e0;\n}\n\n.category-selection .filter-row {\n    margin-bottom: 15px;\n}\n\n.category-selection .filter-row:last-child {\n    margin-bottom: 0;\n}\n\n.help-text {\n    color: #666;\n    font-size: 14px;\n    font-style: italic;\n}\n\n/* 사이드바 스타일 추가 */\n.admin-sidebar {\n    width: 220px;\n    margin-right: 30px;\n}\n\n.sidebar-menu {\n    margin-bottom: 34px;\n}\n\n.sidebar-menu h3 {\n    font-size: 18px;\n    margin: 0 0 15px 0;\n}\n\n.sidebar-menu ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.sidebar-menu ul li {\n    padding: 10px 20px;\n    cursor: pointer;\n    font-size: 14px;\n    color: #717171;\n    transition: background-color 0.2s ease, color 0.2s ease;\n    border-radius: 4px;\n    margin-bottom: 2px;\n}\n\n.sidebar-menu ul li:hover {\n    background-color: #f5f5f5;\n    color: #333;\n}\n\n.sidebar-menu ul li.active {\n    color: black;\n    font-weight: bold;\n    background-color: #e8f4f8;\n}\n\n.admin-content-product {\n    flex-grow: 1;\n}\n\n.product-search-filters {\n    border: 1px solid #ddd;\n    padding: 20px;\n    background-color: #f8f9fa;\n    border-radius: 5px;\n}\n\n.filter-row {\n    display: flex;\n    align-items: center;\n    margin-bottom: 15px;\n    gap: 10px;\n}\n\n.filter-row:last-child {\n    margin-bottom: 0;\n}\n\n.filter-row label {\n    width: 100px;\n    font-weight: bold;\n    flex-shrink: 0;\n}\n\n.filter-select {\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n}\n\n.filter-input {\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    flex-grow: 1;\n}\n\n.filter-date {\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n}\n\n.date-shortcuts {\n    display: flex;\n    gap: 5px;\n    margin-left: 10px;\n}\n\n.date-shortcuts button {\n    padding: 5px 10px;\n    border: 1px solid #ccc;\n    background-color: #fff;\n    cursor: pointer;\n}\n\n.filter-checkboxes {\n    display: flex;\n    gap: 20px;\n}\n\n.filter-checkboxes label {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    width: auto;\n    cursor: pointer;\n}\n\n.filter-checkboxes input[type=\"radio\"] {\n    margin-right: 5px;\n    cursor: pointer;\n}\n\n.display-status-control {\n    display: flex;\n    gap: 15px;\n    align-items: center;\n}\n\n.display-status-control label {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.display-status-control input[type=\"radio\"] {\n    margin: 0;\n    cursor: pointer;\n}\n\n.search-button-product {\n    display: block;\n    width: 343px;\n    padding: 15px;\n    background-color: #222;\n    color: white;\n    font-size: 18px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    margin: 30px auto;\n}\n\n.product-list-container {\n    margin-top: 30px;\n}\n\n.product-list-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 15px;\n}\n\n.product-list-header span {\n    font-size: 16px;\n    font-weight: bold;\n}\n\n.btn-add-product {\n    background-color: white;\n    border: 1px solid #ccc;\n    padding: 10px 20px;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.product-table {\n    width: 100%;\n    border-collapse: collapse;\n    border-top: 2px solid #333;\n}\n\n.product-table th,\n.product-table td {\n    text-align: center;\n    padding: 15px 10px;\n    border-bottom: 1px solid #ddd;\n}\n\n.product-table th {\n    font-weight: bold;\n    background-color: #f8f9fa;\n}\n\n.product-table td img {\n    max-width: 60px;\n    height: auto;\n}\n\n/* 클릭 가능한 행 스타일 */\n.clickable-row {\n    transition: background-color 0.2s ease;\n}\n\n.clickable-row:hover {\n    background-color: #f8f9fa;\n}\n\n/* 첫 번째 컬럼(체크박스 + 버튼) 너비 조정 */\n.product-table th:first-child,\n.product-table td:first-child {\n    width: 150px;\n    min-width: 150px;\n    overflow: visible !important;\n    white-space: nowrap !important;\n}\n\n/* 테이블 내 버튼 스타일 강제 적용 */\n.product-table .product-actions {\n    display: flex !important;\n    flex-direction: row !important;\n    gap: 5px !important;\n    align-items: center !important;\n    justify-content: center !important;\n    min-width: 100px !important;\n}\n\n.product-table .btn-edit-product,\n.product-table .btn-delete-product {\n    display: inline-block !important;\n    padding: 4px 8px !important;\n    font-size: 11px !important;\n    border-radius: 3px !important;\n    border: 1px solid !important;\n    cursor: pointer !important;\n    text-decoration: none !important;\n    min-width: 40px !important;\n}\n\n.product-table .btn-edit-product {\n    background-color: #e84118 !important;\n    color: white !important;\n    border-color: #e84118 !important;\n}\n\n.product-table .btn-edit-product:hover {\n    background-color: #d63384 !important;\n    border-color: #d63384 !important;\n}\n\n.product-table .btn-delete-product {\n    background-color: #6c757d !important;\n    color: white !important;\n    border-color: #6c757d !important;\n}\n\n.product-table .btn-delete-product:disabled {\n    background-color: #f8f9fa !important;\n    color: #6c757d !important;\n    border-color: #dee2e6 !important;\n    cursor: not-allowed !important;\n    opacity: 0.6 !important;\n}\n\n.product-list-actions {\n    margin-top: 20px;\n    display: flex;\n    gap: 10px;\n}\n\n.btn-delete-selected,\n.btn-edit-selected {\n    padding: 10px 20px;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.btn-delete-selected {\n    background-color: #222;\n    color: white;\n    border: none;\n}\n\n.btn-edit-selected {\n    background-color: white;\n    border: 1px solid #ccc;\n}\n\n.pagination {\n    margin-top: 30px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 20px;\n}\n\n.pagination button {\n    background: none;\n    border: 1px solid #ccc;\n    padding: 5px 10px;\n    cursor: pointer;\n}\n\n/* 제품 관리 버튼 스타일 */\n.product-actions {\n    display: flex;\n    flex-direction: row;\n    gap: 8px;\n    align-items: center;\n    justify-content: center;\n    min-width: 120px;\n}\n\n.btn-back-product,\n.btn-edit-product,\n.btn-delete-product {\n    padding: 6px 12px;\n    border-radius: 4px;\n    font-size: 12px;\n    cursor: pointer;\n    border: 1px solid;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    white-space: nowrap;\n    min-width: 50px;\n}\n\n.btn-back-product {\n    background-color: #6c757d;\n    color: white;\n    border-color: #6c757d;\n}\n\n.btn-back-product:hover {\n    background-color: #5a6268;\n    border-color: #545b62;\n}\n\n.btn-edit-product {\n    background-color: #e84118;\n    color: white;\n    border-color: #e84118;\n}\n\n.btn-edit-product:hover {\n    background-color: #d63384;\n    border-color: #d63384;\n}\n\n.btn-delete-product {\n    background-color: #6c757d;\n    color: white;\n    border-color: #6c757d;\n}\n\n.btn-delete-product:hover:not(:disabled) {\n    background-color: #dc3545;\n    border-color: #dc3545;\n}\n\n.btn-delete-product:disabled {\n    background-color: #f8f9fa;\n    color: #6c757d;\n    border-color: #dee2e6;\n    cursor: not-allowed;\n    opacity: 0.6;\n}\n\n.arrow-icon {\n    font-size: 12px;\n    font-weight: bold;\n    line-height: 1;\n}\n\n/* Tablet and smaller devices */\n@media (max-width: 1024px) {\n    .filter-row {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 5px;\n    }\n    \n    .filter-row label {\n        width: 100%;\n    }\n\n    .filter-select,\n    .filter-input {\n        width: 100%;\n    }\n\n    .date-shortcuts {\n        margin-left: 0;\n    }\n\n    .search-button-product {\n        width: 100%;\n    }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .product-list-header {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 10px;\n    }\n\n    .product-table thead {\n        display: none;\n    }\n\n    .product-table, .product-table tbody, .product-table tr, .product-table td {\n        display: block;\n        width: 100%;\n    }\n\n    .product-table tr {\n        margin-bottom: 15px;\n        border: 1px solid #ddd;\n        border-radius: 5px;\n        overflow: hidden;\n    }\n\n    .product-table td {\n        text-align: right;\n        padding-left: 50%;\n        position: relative;\n    }\n    \n    .product-table td::before {\n        content: attr(data-label);\n        position: absolute;\n        left: 15px;\n        width: calc(50% - 30px);\n        padding-right: 10px;\n        white-space: nowrap;\n        text-align: left;\n        font-weight: bold;\n    }\n    \n    .product-list-actions {\n        flex-direction: column;\n    }\n    \n    .btn-delete-selected,\n    .btn-edit-selected {\n        width: 100%;\n    }\n    \n    .product-actions {\n        flex-direction: row;\n        gap: 5px;\n        min-width: auto;\n    }\n    \n    .btn-back-product,\n    .btn-edit-product,\n    .btn-delete-product {\n        max-width: 60px;\n        padding: 4px 6px;\n        font-size: 11px;\n        min-width: 40px;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
